export default "__VITE_ASSET__CFPCLiIe__"